import { css, cx } from 'linaria';
import { ReactNode } from 'react';
import { cssTheme } from '@uds/theme-utils';
import Colorway, { Colorways } from '@uds/colorway';

const stickyContainer = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${cssTheme.zIndex.sticky};

  backdrop-filter: blur(8px);
  background-color: rgba(var(--wash-color), 0.9);
  border-bottom: 2px solid ${cssTheme.palette.grey10};

  transform: translateY(-100%);

  @media (prefers-reduced-motion: no-preference) {
    transition: transform 0.3s ease-in;
  }
`;
const hidden = css`
  visibility: hidden;
`;

const washColor: Record<Colorways, string> = {
  LIGHT: css`
    --wash-color: 255, 255, 255;
  `,
  NEUTRAL: css`
    --wash-color: ${cssTheme.palette.rgb.grey12};
  `,
  DARK: css`
    --wash-color: 0, 0, 0;
  `,
  PRIMARY: css`
    --wash-color: ${cssTheme.palette.rgb.primary};
  `,
  PRIMARY_GRADIENT: css`
    --wash-color: ${cssTheme.palette.rgb.primary};
  `,
  HIGHLIGHT: css`
    --wash-color: ${cssTheme.palette.rgb.highlight};
  `,
};

const visible = css`
  transform: translateY(0);
`;

type Props = {
  children: ReactNode;
  isSticky: boolean;
  isVisible: boolean;
  colorway: Colorways;
};

export default function StickyContainer({ isVisible, children, colorway, isSticky }: Readonly<Props>): JSX.Element {
  return (
    <Colorway
      colorway={colorway}
      className={cx(stickyContainer, washColor[colorway], !isSticky && hidden, isVisible && visible)}
    >
      {children}
    </Colorway>
  );
}
